import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, PropType, computed } from 'vue';
import SvgIcon from '../SvgIcon.vue';
import success from './images/success.vue';
import error from './images/error.vue';
import warning from './images/warning.vue';
import info from './images/info.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Message',
  props: {
  type: {
    type: String as PropType<'success' | 'error' | 'warning' | 'info'>,
    default: 'success',
  },
  message: {
    type: [String, Number],
    default: '',
  },
  duration: {
    type: Number,
    default: 3000,
  },
  remove: {
    type: Function,
    default: () => {},
  },
  top: {
    type: Object,
    default: () => {},
  },
  zIndex: {
    type: Number,
    default: 1000,
  },
},
  setup(__props) {

const props = __props;



const svgName = computed(() => {
  const svgMap = { success, error, warning, info };
  return svgMap[props.type] || info;
});

const messageRef = ref();
const isShow = ref(false);
onMounted(async () => {
  onOpen();
});

const timer = ref();
const onOpen = () => {
  isShow.value = true;
  timer.value && clearTimeout(timer.value);
  timer.value = setTimeout(() => {
    onClose();
  }, props.duration);
};
const onClose = () => {
  isShow.value = false;
  props.remove();
};

return { __sfc: true,props, svgName, messageRef, isShow, timer, onOpen, onClose, SvgIcon }
}

})